import React from "react";
import { motion } from "framer-motion";
import "../styles/PartnerLogos.css";

const clients = [
    { name: "Kaushalya Art Jewellery", link: "https://kaushalyaartjewellery.com", logoFile: "kaushalyaartjewellery.png", width: 600, height: 600 },
    { name: "Crown & Halo", link: "https://crownandhalo.co.uk/", logoFile: "crownandhalo.jpg", width: 1500, height: 1500 },
    { name: "Avinyaan", link: "https://avinyaan.com/", logoFile: "avinyaan.jpeg", width: 1024, height: 1024 },
    { name: "Mobiebook", link: "https://mobiebook.online/#/home", logoFile: "mobiebook.png", width: 500, height: 500 },
    { name: "Khar Jamaat", link: "https://kharjamaat.in/", logoFile: "kharjamaat.jpeg", width: 1080, height: 1208 },
    { name: "Verity iGrills", link: "https://veritygrills.com/", logoFile: "verityigrills.png", width: 500, height: 500 },
    { name: "Wellness Shoppee", link: "https://wellnessshoppee.com/", logoFile: "wellnessshoppee.jpeg", width: 225, height: 225 },
    { name: "Maxcient Technologies", link: "https://maxcient.com/", logoFile: "maxcient_technologies_logo.jpeg", width: 200, height: 200 },
    { name: "Verity Ateliers", link: "https://verityateliers.com/", logoFile: "verityatelier.png", width: 500, height: 500 },
    { name: "Verity Aluminium System", link: "https://verityalu.com/", logoFile: "verity alu.jpeg", width: 500, height: 500 },
];

const getClientLogoSrc = (logoFile) => {
    const base = `${process.env.PUBLIC_URL}/assets/client%20logos/`;
    return `${base}${encodeURIComponent(logoFile)}`;
};

const toWebpFileName = (logoFile) => logoFile.replace(/\.[^.]+$/, ".webp");

const PartnerLogos = () => {
    return (
        <section className="partners-section">
            <div className="container">
                <div className="partners-header">
                    <motion.p
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        className="partners-intro"
                    >
                        We pride ourselves on the strength of our relationships. <br />
                        Here are some of the brands we've worked with:
                    </motion.p>
                </div>

                <div className="partners-grid">
                    {clients.map((client, index) => (
                        <motion.a
                            key={index}
                            href={client.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.05 }}
                            className="partner-logo-card glass-morphism"
                            aria-label={client.name}
                            title={client.name}
                        >
                            <picture>
                                <source
                                    srcSet={getClientLogoSrc(toWebpFileName(client.logoFile))}
                                    type="image/webp"
                                />
                                <img
                                    className="partner-logo"
                                    src={getClientLogoSrc(client.logoFile)}
                                    alt={client.name}
                                    width={client.width}
                                    height={client.height}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </picture>
                        </motion.a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PartnerLogos;
